'use strict';

export default class AlarmCloseActionsComponent {
	public restrict: any;
	public template: any;
	public scope: any;

  constructor() {
    this.restrict = 'E'
    this.template = require('./alarm.closeactions.component.html'),
      this.scope = {
        alarm: '='
      }
  }
  controller() {
  }
}